import { Modal } from "react-bootstrap";
import { useState } from "react";

const DeleteWorklistModal = ({
  onDeleteHandler,
  showModalBox,
  worklistId,
  closeModal,
}) => {
  const [typedWorklistId, setTypedWorklistId] = useState("");
  const [error, setError] = useState(false);
  const [isSubmitting, updateSubmissionState] = useState(false);

  return (
    <Modal show={showModalBox}>
      <Modal.Header>
        <h2 className="fw-bold">Delete Worklist</h2>
      </Modal.Header>
      <div className="modal-body scroll-y my-5">
        <form
          onSubmit={async (e) => {
            e.preventDefault();

            if (typedWorklistId === worklistId) {
              updateSubmissionState(true);
              await onDeleteHandler(e);
            } else {
              setError(true);
            }
            updateSubmissionState(false);
          }}
        >
          <div className="row mb-4">
            <div className="col-12">
              <label className="required form-label">Worklist Id</label>
              <input
                className="form-control"
                type="text"
                minlength={1}
                maxlength={100}
                onChange={(e) => {
                  setTypedWorklistId(e.target.value);
                  setError(false);
                }}
              />
              {error && (
                <small className="text-danger">
                  The worklist Ids don't match
                </small>
              )}
            </div>
          </div>
          <div className="text-center pt-8">
            <button
              type="button"
              className="btn btn-light me-3"
              onClick={closeModal}
            >
              Cancel
            </button>
            <button
              type="submit"
              className={`btn ${
                isSubmitting ? "btn-secondary" : "btn-primary"
              }`}
              disabled={isSubmitting}
            >
              <span className="indicator-label">
                {isSubmitting ? "Please wait..." : "Delete Worklist"}
              </span>
            </button>
          </div>
        </form>
      </div>
    </Modal>
  );
};

export default DeleteWorklistModal;
